import React from 'react';

import {removeEventFamilyByName} from 'src/openapi/apis/EventFamilyControllerApi';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {OnCloseNote} from '@pb/kit-component-push-notification';

type Props = {
    name: string,
    onClose: OnCloseNote,
    onError: (message?: string) => void,
};

export const PushNotificationRemoveEventFamily = ({name, onClose, onError}: Props) => {
    const dispatch = useAppDispatch();
    const onClick = async () => {
        const response = await dispatch(removeEventFamilyByName({name}));

        if (response.payload.success) {
            await onClose(`${name}`);
        }

        if (response.payload.error) {
            onError(response.payload?.data?.message);
        }
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group gap="none" style={{maxWidth: '90%'}}>
                <Group gap="xs" style={{minWidth: '70%'}}>
                    <Item>Delete event family <strong>{name}</strong>?</Item>
                </Group>
            </Group>
            <FlatButton onClick={onClick}>Delete</FlatButton>
        </Group>
    );
};
